import React from 'react';
import styled from 'styled-components';

function Navbar({navbarSelected, setNavbarSelected}) {
    return (
        <NavBar>
            <div>
                <ul>
                    <li className={navbarSelected === "furniture" ? "active" : ""} onClick={() => setNavbarSelected("furniture")}>
                        <h3>Furniture</h3>
                    </li>
                    <li className={navbarSelected === "cutting_boards" ? "active" : ""} onClick={() => setNavbarSelected("cutting_boards")}>
                        <h3>Cutting Boards</h3>
                    </li>
                    <li className={navbarSelected === "miscellaneous" ? "active" : ""} onClick={() => setNavbarSelected("miscellaneous")}>
                        <h3>Miscellaneous</h3>
                    </li>
                </ul>
            </div>
        </NavBar>
    )
}


const NavBar = styled.div`
    h3 {
        font-size: 3.7vw;
        color: #e0b6dc;
        background: none;
        font: bold;
    }

    .active {
        background-color: rgb(35, 28, 42);
    }

    li:hover {
        cursor: pointer;
    }
`


export default Navbar
